var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 16.7148C9.56138 16.7148 9.40179 16.6496 9.27121 16.519L2.48103 9.96819C2.40848 9.91016 2.30873 9.81585 2.18178 9.68527C2.05483 9.55469 1.85352 9.3171 1.57785 8.97252C1.30218 8.62793 1.05552 8.27427 0.837891 7.91155C0.620257 7.54883 0.4262 7.10993 0.25572 6.59487C0.0852399 6.0798 0 5.57924 0 5.09319C0 3.49721 0.460659 2.24944 1.38198 1.34989C2.30329 0.450335 3.57645 0.000558853 5.20145 0.000558853C5.65123 0.000558853 6.11007 0.0785446 6.57799 0.234516C7.0459 0.390488 7.48117 0.600866 7.88379 0.865654C8.28641 1.13044 8.63281 1.37891 8.92299 1.61105C9.21317 1.84319 9.48884 2.08984 9.75 2.35101C10.0112 2.08984 10.2868 1.84319 10.577 1.61105C10.8672 1.37891 11.2136 1.13044 11.6162 0.865654C12.0188 0.600866 12.4541 0.390488 12.922 0.234516C13.3899 0.0785446 13.8488 0.000558853 14.2985 0.000558853C15.9235 0.000558853 17.1967 0.450335 18.118 1.34989C19.0393 2.24944 19.5 3.49721 19.5 5.09319C19.5 6.69643 18.6694 8.32868 17.0081 9.98996L10.2288 16.519C10.0982 16.6496 9.93862 16.7148 9.75 16.7148Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFilled);
export default __webpack_public_path__ + "static/media/heart_filled.4e84d8b8fd66767a9b8be4ce46fd35eb.svg";
export { ForwardRef as ReactComponent };